import { render } from "./ModelTyre.vue?vue&type=template&id=9b301750&scoped=true"
import script from "./ModelTyre.vue?vue&type=script&lang=js"
export * from "./ModelTyre.vue?vue&type=script&lang=js"

import "./ModelTyre.vue?vue&type=style&index=0&id=9b301750&lang=scss&scoped=true"

import exportComponent from "/Users/chrismains/Sites/fixmycar/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9b301750"]])

export default __exports__